// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2vwgO","name":"Header_name__35jzp","birthday":"Header_birthday__16yqo","skeleton":"Header_skeleton__YLJDW"};